'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = parseUrl;

function parseUrl(url, params) {
  return url.replace(/(:)([A-Za-z][A-Za-z0-9]*)/g, function (match, $1, $2) {
    var paramType = _typeof(params[$2]);

    if (paramType !== 'string' && paramType !== 'number') {
      throw new Error('Param ' + $2 + ' from url ' + url + ', not found in params object');
    }

    return params[$2];
  });
}